
import axios from "axios"
import moment from 'moment'
import { LIMITE_REGISTROS_PESQUISA } from '../../../static/parametros/parametros.js'

export default {
  namespaced: true,
  state: {
      lista: [],
      perPage: 100,
      registroSelecionadoId: null,
      paginaAtual: 1,
      dt1: moment().format('YYYY-MM-DD'),
      dt2: moment().format('YYYY-MM-DD'),
      id: null,
      documento: null,
      tipoData: 'V',
      clienteId: null,
      totalTitulos: 0,
      totalEmDias: 0,
      totalAtrasado: 0,
      quantTitulos: 0,
  },
  getters: {
    LISTA: state => {
        return state.lista
    },
    PER_PAGE: state => { 
        return state.perPage
    },
    REGISTRO_SELECIONADO_ID: state => {
        return state.registroSelecionadoId
    },
    PAGINA_ATUAL: state => {
        return state.paginaAtual
    },
    DT1: state => {
        return state.dt1
    },
    DT2: state => {
        return state.dt2
    },
    ID: state => {
        return state.id
    },
    CLIENTE_ID: state => {
        return state.clienteId
    },
    DOCUMENTO: state => {
        return state.documento
    },
    TIPO_DATA: state => {
        return state.tipoData
    },
    TOTAL_TITULOS: state => {
        return state.totalTitulos
    },
    TOTAL_EM_DIAS: state => {
        return state.totalEmDias
    },
    TOTAL_ATRASADO: state => {
        return state.totalAtrasado
    },
    QUANT_TITULOS: state => {
        return state.quantTitulos
    },
    TOTAL_TITULOS: state => {
        return state.totalTitulos
    },
    TOTAL_EM_DIAS: state => {
        return state.totalEmDias
    },
    TOTAL_ATRASADO: state => {
        return state.totalAtrasado
    },
    QUANT_TITULOS: state => {
        return state.quantTitulos
    }
  },
  /** MUTACOES SAO SINCRONAS - SEMELHANTES AO COMPUTED */
  mutations: {
    SET_LISTA: (state, payload) => {
        state.lista = payload
    },
    SET_REGISTRO_SELECIONADO_ID: (state, payload) => {
        state.registroSelecionadoId = payload
    },
    SET_PAGINA_ATUAL: (state, payload) => {
        state.paginaAtual = payload
    },
    SET_PER_PAGE: (state, payload) => {
        state.perPage = payload
    },
    SET_DT1: (state, payload) => {
        state.dt1 = payload
    },
    SET_DT2: (state, payload) => {
        state.dt2 = payload
    },
    SET_ID: (state, payload) => {
        state.id = payload
    },
    SET_CLIENTE_ID: (state, payload) => {
        state.clienteId = payload
    },
    SET_DOCUMENTO: (state, payload) => {
        state.documento = payload
    },
    SET_TIPO_DATA: (state, payload) => {
        state.tipoData = payload
    },
    SET_TOTAL_TITULOS: (state, payload) => {
        state.totalTitulos = payload
    },
    SET_TOTAL_EM_DIAS: (state, payload) => {
        state.totalEmDias = payload
    },
    SET_TOTAL_ATRASADO: (state, payload) => {
        state.totalAtrasado = payload
    },
    SET_QUANT_TITULOS: (state, payload) => {
        state.quantTitulos = payload
    },
    SET_RESUMO: (state, payload) => {
        state.totalTitulos = 0
        state.totalEmDias = 0
        state.totalAtrasado = 0
        state.quantTitulos = 0
        for (let i = 0; i < payload.length; i++) {
            state.quantTitulos += 1
            state.totalTitulos += payload[i].VL_APAGAR
            if ( moment(payload[i].DT_VENC).format('YYYY-MM-DD')  < moment().format('YYYY-MM-DD')  ) {
            state.totalAtrasado += payload[i].VL_APAGAR
            } else {
            state.totalEmDias += payload[i].VL_APAGAR
            }
        }
    },
    SET_LIMPAR_APENAS_FILTRO: (state, payload) => {
        state.perPage = 100
        state.registroSelecionadoId = null
        state.paginaAtual = 1
        state.dt1 = moment().format('YYYY-MM-DD')
        state.dt2 = moment().format('YYYY-MM-DD')
        state.id = null
        state.documento = null
        state.tipoData = 'V'
        state.clienteId = null
        state.totalTitulos = 0
        state.totalEmDias = 0
        state.totalAtrasado = 0
        state.quantTitulos = 0
    }
      
  },
  /** ACTOINS SAO ASSINCRONOS */
  actions: {
    GERAR_LISTA: ({ commit, getters}, { skipConfirmation = false } = {}) => {
        return new Promise((resolve, reject) => {
          let id = (getters.ID !== null ? getters.ID : '')
          let clienteId = (getters.CLIENTE_ID !== null ? getters.CLIENTE_ID : '')
          let documento = (getters.DOCUMENTO !== null ? getters.DOCUMENTO : '')
          let tipoData = (getters.TIPO_DATA !== null ? getters.TIPO_DATA : '')
          let dt1 = (getters.DT1 !== null ? getters.DT1 : '')
          let dt2 = (getters.DT2 !== null ? getters.DT2 : '')

          let uri = `/api/protected/apagar/pesquisar?id=${id}&dt1=${dt1}`+
          `&dt2=${dt2}&documento=${documento}&tipoData=${tipoData}`+
          `&clienteid=${clienteId}`
          axios
            .get(uri)
            .then(({ data, status }) => {
              // Verifica se o resultado tem mais de LIMITE_REGISTROS_PESQUISA registros e precisa de confirmação
              if (!skipConfirmation && data && data.length > LIMITE_REGISTROS_PESQUISA) {
                // Retorna os dados sem comitar, indicando que precisa de confirmação
                resolve({ 
                  data, 
                  status,
                  needsConfirmation: true,
                  count: data.length
                });
                return
              }
              
              commit("SET_LISTA", data)
              commit("SET_RESUMO", data)
              if (status === 200 || status === 201) {
                resolve({ data, status, needsConfirmation: false });
              }
            })
            .catch(error => {
              reject(error);
            });
        });
      },
  }
}


// WEBPACK FOOTER //
// ./src/vuex/modulos/apagar-store.js